<template>
  <div class="base-badge"><slot>0</slot></div>
</template>
